//Formik
import { useField } from "formik"

//primeReact
import { Editor } from 'primereact/editor';

export default function TaskCreateFormNotesInput() {
    const [field, , helpers] = useField("description")

        return (
        <div style={{ marginBottom: 10 }}>
            <div style={{ fontWeight: "bold" }}>Notes</div>
            <div>
            <Editor 
                value={field.value}
                onTextChange={(e) => helpers.setValue(e.htmlValue)}
                style={{ height: "235px", wordBreak: "break-all" }}
            />
            </div>
        </div>
        )
}